import CurrentUserStore from 'mewe/stores/current-user-store';
import ChatStore from 'mewe/stores/chat-store';
import GroupStore from 'mewe/stores/group-store';
import ChatApi from 'mewe/api/chat-api';
import { retryHttp500UntilDone } from 'mewe/utils/fetch-utils';
import { ChatFilter } from 'mewe/constants';

const hasFilter = (options) => options && options.chatType && options.chatType !== ChatFilter.ALL;

const addType = (params, options) =>
  hasFilter(options) ? Object.assign(params, { chatType: options.chatType }) : params;

export default function (options) {
  CurrentUserStore.getState().deferred.promise.then(() => {
    ChatApi.getUnreadCount().then((data) => {
      ChatStore.send('setUnreadCount', data.count);
    });

    const params = addType({ addRequests: true && !hasFilter(options) }, options);

    if (params.chatType) {
      ChatStore.getState().set('isFetchingWithFilter', true);
    }

    retryHttp500UntilDone(() => ChatApi.getThreads(params))
      .connectionIssue(() => {
        ChatStore.send('connectionIssue');
      })
      .then((data) => {
        if (!data || !data.threads) return;

        let chatSource = params.chatType ? params.chatType : ChatFilter.ALL;

        // make sure groups are loaded before handling threads, for user with huge number of groups
        // the fetching/serialising process can take a longer while and there are problems in serialising group threads
        GroupStore.getState().deferred.promise.then(() => {
          ChatStore.send('handleRawThreads', data, options, chatSource);
          ChatStore.send('handleChatRequests', data);
        });

      })
      .finally(() => {
        ChatStore.getState().set('isFetchingWithFilter', false);
      });
  });
}
